import SelectableSearch from '../../components/SelectableSearch'
import { useDispatch } from 'react-redux'
import { setQueryParam } from './membershipSlice'
import '../../App.scss'
import { create } from '../Radiology/Constants/constants'
import KeycloakService from '../../utils/keycloakService'
import { ADMIN_EXPORT_DATA } from '../../utils/roles'
import { refactoredData } from './utils'
import ExportButton from '../../components/ExportButton'
import { selectableSearchOptions } from './models'

type Props = {
  onCreate: () => void
  onPremiumCalculate?: () => void
  memberships: any[]
}

const MembershipSearch = ({
  onCreate,
  memberships,
  onPremiumCalculate,
}: Props) => {
  const dispatch = useDispatch()
  const handleSearch = (query: string, param: string) => {
    let q = ''
    switch (query) {
      case 'ID':
        q = 'partner'
        break
      case 'Phone':
        q = 'phone'
        break
      case 'Name':
        q = 'name'
        break
    }

    dispatch(setQueryParam({ q, param }))
  }

  return (
    <div className='membership-filter'>
      <ExportButton
        data={refactoredData(memberships)}
        disabled={
          !KeycloakService?.hasRole([ADMIN_EXPORT_DATA]) &&
          memberships?.length === 0
        }
      />
      <SelectableSearch
        items={selectableSearchOptions}
        onSearch={handleSearch}
      />

      <button className='btn btn-primaryBtn' onClick={() => onCreate()}>
        {create}
      </button>
      {onPremiumCalculate && (
        <button
          className='btn btn-primaryBtn'
          onClick={() => onPremiumCalculate?.()}
        >
          Premium Calculator
        </button>
      )}
    </div>
  )
}

export default MembershipSearch
